// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .x_panel {
        position: relative;
        width: 100%;
        margin-bottom: 10px;
        padding: 10px 17px;
        display: inline-block;
        background: #fff;
        border: 1px solid #E6E9ED;
        -webkit-column-break-inside: avoid;
        -moz-column-break-inside: avoid;
        /* column-break-inside: avoid; */
        opacity: 1;
        transition: all .2s ease;
    }`, "",{"version":3,"sources":["webpack://./src/Sidebar/InsuranceCategories.css"],"names":[],"mappings":"CAAC;QACO,kBAAkB;QAClB,WAAW;QACX,mBAAmB;QACnB,kBAAkB;QAClB,qBAAqB;QACrB,gBAAgB;QAChB,yBAAyB;QACzB,kCAAkC;QAClC,+BAA+B;QAC/B,gCAAgC;QAChC,UAAU;QACV,wBAAwB;IAC5B","sourcesContent":[" .x_panel {\r\n        position: relative;\r\n        width: 100%;\r\n        margin-bottom: 10px;\r\n        padding: 10px 17px;\r\n        display: inline-block;\r\n        background: #fff;\r\n        border: 1px solid #E6E9ED;\r\n        -webkit-column-break-inside: avoid;\r\n        -moz-column-break-inside: avoid;\r\n        /* column-break-inside: avoid; */\r\n        opacity: 1;\r\n        transition: all .2s ease;\r\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
